import React, { useEffect, useState } from 'react';
import { withRouter, Route, Redirect, matchPath } from 'react-router-dom';
import {
  findInvestmentPoolOptionsByAccountIdStartDateAndEndDate,
  getActiveExchangeScheduleCount,
  getTradeCutOffDateAndTime,
  findSingleExchangeDetailsByAccountIdAndExchangeId,
  findRecurringExchangeDetailsByAccountIdAndScheduleId,
  findExchangeSpawnDetailsByScheduleIdAndSpawnId,
  getCSRBusinessFunctionFromGemini,
  getPendingTIFF
} from '../../../../services/apiServices';
import { FixedWidth } from '../../../../CommonComponents/commonStyles';
import { getPrimaryAccount, getAccountData } from '../../../../utils/sessionUtil';
import { milliToDateTime, todayDate, startDate, initiateTracking,isAllShareAllPool } from '../../../../utils/commonUtil';
import { RecommendExchangeSection } from './styles';
import ExchangeFrom from './components/exchangeFrom';
import ExchangeTo from './components/exchangeTo';
import ExchangeReview from './components/exchangeReview';
import { Provider } from './context';
import Stepper from './components/stepper';
import { ExchangeStep as Step } from './components/stepper/styles';
import Title from './components/stepper/Title';
import Popover from './components/stepper/Popover';
import Confirmation from './components/confirmation';
import {
  ScheduleType as ScheduleTypeConstants,
  ExchangeType as ExchangeTypeConstants,
  AllocationType as AllocationTypeConstants,
  EditExchangeDetailStatuses,
  DateTimeFormat,
  ContactUsNumber,
  ContactUsEmail,
  isTIFF,
} from './constants';
import Alerts from './components/alerts';
import AccountSummary from './components/accountSummary';
import ViewAndEdit from './components/viewAndEdit';
import ExchangeFromInfo from './components/exchangeFrom/Info';
import ExchangeToInfo from './components/exchangeTo/Info';
import VeiwSpawn from './components/viewSpawn';
import { mapSingleExchangeToContext, mapSpawnExchangeToContext, getInitialData, 
  mapRecurringExchangeToContext, initState, isFreezeUser, calculateIntialParams, isReadOnlyWithExchangeRole } from './util';
import moment from 'moment';
import { ContentProvider, ContentMessage, Types, AlertContent } from '../../../../CommonComponents/ContentMessages';
import { AlertMessage } from './components/popup';
import { convertArrayElemToLowerCase } from '../../../../CSR/utils/CommonUtils';
import queryString from "query-string";
import { getFreezeFeaturesList } from '../../../../utils/freezeUtil';


const breadcrumbRoutes = [
  {
    routeName: 'Home',
    path: '/',
  },
  {
    routeName: 'Investments',
    path: '/investments',
  },
  {
    routeName: 'Recommend an Exchange',
    path: '/investments/recommend-an-exchange',
  },
];

export const checkTiffBalance = (pools) => {
  if(pools && pools.length > 0) {
    const tiffPool = pools.find((pool, i) => pool.poolName.replace(' Select', '') === 'TIFF Multi-Asset Pool');
    if(tiffPool && tiffPool.availableBalance > 0) {
      return true;
    } else {
      return false;
    }
  } 
}

export const trackExitButton = (scheduleType, location) => {
  const scheduleTypeLabel = scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
  if (location.pathname === '/investments/recommend-an-exchange/NEW/from') {
    initiateTracking('exit', 'Recommend An Exchange', 'Step 1 Recommend exchange from', `Exit - ${scheduleTypeLabel}`);
  } else if (location.pathname === '/investments/recommend-an-exchange/NEW/to') {
    initiateTracking('exit', 'Recommend An Exchange', 'Step 2 Recommend exchange to', `Exit - ${scheduleTypeLabel}`);
  } else if (location.pathname === '/investments/recommend-an-exchange/NEW/review') {
    initiateTracking('exit', 'Recommend An Exchange', 'Step 3 Review exchange and submit', `Exit - ${scheduleTypeLabel}`);
  }
}

export const RecommendAnExchange = (props) => {
  const { history, location } = props;
  const params = calculateIntialParams({location});
  const { isNewParam, editParam, typeParam, scheduleTypeParam, exhchangeTypeParam, isRecommendFromParam, exchPendingSpawnIdParam, exchangeIdParam, isReturnedParam} = params;
  const { userId, role, freezes, accountType } = getPrimaryAccount();
  const { partyFreezes = [] } = getAccountData();
  //const accountLocked = isFreezeUser(freezes);
  const accountLocked = getFreezeFeaturesList(partyFreezes, freezes).includes('RAE');

  /** Effects */
  const [exchangeContext, setExchangeContext] = React.useReducer((prev, current) => {
    return { ...prev, ...current };
  }, initState());
  const [investmentPoolOptions, setInvestmentPoolOptions] = useState({});
  const [activeExchangeScheduleCount, setActiveExchangeScheduleCount] = useState(0);
  const [tradeCutoffDateAndTime, setTradeCutoffDateAndTime] = useState(null);
  const [scheduleType, setScheduleType] = useState(scheduleTypeParam || exchangeContext.from.scheduleType || ScheduleTypeConstants.onetime); // This state is to identify type of schedule
  const [exchangeType, setExchangeType] = useState(exhchangeTypeParam || exchangeContext.from.exchangeType); // This state is used to identify exchange type custom/reallocation
  const [exchangeDetails, setExchangeDetails] = useState(); // For existing exchange details, this must not be used to store new exchange details
  const [edit, setEdit] = useState(role && (role.access === 'All Access' || isReadOnlyWithExchangeRole) && editParam);
  const [isNew, setNew] = useState(isNewParam);
  const [exchangeId, setExchangeId] = useState(!isNewParam && exchangeIdParam);
  const [type, setType] = useState(typeParam);
  const [exchPendingSpawnId, setExchPendingSpawnId] = useState(exchPendingSpawnIdParam);
  const [isRecommendFrom, setRecommendFrom] = useState(isRecommendFromParam);
  const [spawnsLoading, setSpawnsLoading] = useState(false);
  const [isPendingTiff, setPendingTiff] = useState(false);
  const [isTiff, setIsTiffClicked] = useState(false);
  const [hasTiffBalance, setTiffBalance] = useState(false) 

  /** Handling for Pop-ups - start */
  const [isExit, setExit] = useState(false);
  const [isCancel, setCancel] = useState(false);
  const [isCancelSpawn, setCancelSpawn] = useState(false);
  const [isBalanceDiffWithPendingTransaction, setBalanceDiffWithPendingTransaction] = useState(false);
  const [isPendingTransactionForRellocationExchange, setPendingTransactionForRellocationExchange] = useState(false);
  const [isMaxRecurring, setMaxRecurring] = useState(false);
  const [isDirty, setDirty] = useState(false); // Status to check if user has updated data in UI or not
  const [isUpdateScheduleTypeAfterChanges, setUpdateScheduleTypeAfterChanges] = useState({ display: false });
  const [isBalanceZero, setBalanceZero] = useState(false);
  const [isReturned, setReturned] = useState(isReturnedParam); // Do not show alert popup if user us returning back to page
  const [isLoading, setIsloading] = useState(false)
  /** Handling for Pop-ups - end */
  const query = queryString.parse(location?.search);
  // To store business function from API
  const [csrBusinessFunction, setCsrBusinessFunction] = useState([]);

  // Update the params if location changes
  useEffect(() => {
    const params = calculateIntialParams({location});
    const { isNewParam, editParam, typeParam, scheduleTypeParam, exhchangeTypeParam, 
      isRecommendFromParam, exchPendingSpawnIdParam, exchangeIdParam, isReturnedParam} = params;
    setBalanceDiffWithPendingTransaction(false);
    setNew(isNewParam);
    setEdit(role && (role.access === 'All Access' || isReadOnlyWithExchangeRole) && editParam);
    typeParam && setType(typeParam);
    scheduleTypeParam && setScheduleType(scheduleTypeParam);
    exhchangeTypeParam && setExchangeType(exhchangeTypeParam);
    setRecommendFrom(isRecommendFromParam);
    exchPendingSpawnIdParam && setExchPendingSpawnId(exchPendingSpawnIdParam);
    exchangeIdParam && setExchangeId(exchangeIdParam);
    setReturned(isReturnedParam);
  }, [location]);

  
  // To get the list of available investment options irrespective of user's allocation
  const initialApiCall = () => {
    findInvestmentPoolOptionsByAccountIdStartDateAndEndDate({ userId, startDate: startDate(7), endDate: todayDate() }).then((res) => {
      setInvestmentPoolOptions(res.data);
      setTiffBalance(checkTiffBalance(res.data.investmentPools));
    }).catch((err) => {
      setInvestmentPoolOptions({});
    })

    // To get the count of existing recurring exchanges
    getActiveExchangeScheduleCount({ userId }).then((res) => {
      setActiveExchangeScheduleCount((res.data && res.data.activeExchangeScheduleCount) || 0);
    }).catch((err) => {
      setActiveExchangeScheduleCount(0);
    });

    // To get the time of trade cutoff date
    getTradeCutOffDateAndTime({ userId }).then((res) => {
      setTradeCutoffDateAndTime(res.data);
    }).catch((err) => {
      setTradeCutoffDateAndTime();
    });

    // To get the CSR Business function
    getCSRBusinessFunctionFromGemini().then((res) => {
      setCsrBusinessFunction(convertArrayElemToLowerCase(res.data));
    }).catch((err) => {
      setCsrBusinessFunction();
    });

    getPendingTIFF({ userId }).then((res)=> {
      setPendingTiff(res.data.tiffExchangePending);
    }).catch((err) => {
      setPendingTiff(false);
    });

    // Cleaning up the conext in session storage when user navigates to pages other than recommend exchange
    const unlisten = history.listen((location, action) => {
      if (location.pathname && !location.pathname.startsWith('/investments/recommend-an-exchange')) {
        window.sessionStorage.removeItem('recommend-an-exchange');
      }
    });
    return () => {
      unlisten();
    }
  }
  /** Effect only for Component Mount - end */
  useEffect(() => {
    if( location.state && location.state.fromMenu) {
        // do nothing
    } else {
      initialApiCall();
    }
  }, [])

  useEffect(() => {
    if( location.state && location.state.fromMenu) {
      setInvestmentPoolOptions({})
      initialApiCall()
    }
  }, [location?.state && location.state.fromMenu])

  useEffect(() => {
    if(!isReturned && isNew && !edit && investmentPoolOptions && investmentPoolOptions.investmentPools) {
      setBalanceDiffWithPendingTransaction(investmentPoolOptions.hasPendingTransaction || hasTiffBalance ||  investmentPoolOptions.currentBalance !== investmentPoolOptions.availableBalance || isPendingTiff || (activeExchangeScheduleCount > 0));
    }
    if (investmentPoolOptions) {
      investmentPoolOptions.availableBalance !== undefined && setBalanceZero(!Boolean(investmentPoolOptions.availableBalance));
    }
  }, [isNew, edit, investmentPoolOptions, isReturned, activeExchangeScheduleCount, isPendingTiff, hasTiffBalance]);

  useEffect(() => {
    const {
      isNewParam: isNew, typeParam: type,
      exchPendingSpawnIdParam: exchPendingSpawnId, exchangeIdParam: exchangeId
    } = calculateIntialParams({location});
    if (!isNew) { // Get exchange details only if not new
      if (type === ScheduleTypeConstants.onetime && exchangeId) {
        setIsloading(true)
        findSingleExchangeDetailsByAccountIdAndExchangeId({ accountId: userId, exchangeId }).then((res) => {
          const { singleExchange: exchange } = res.data;
          setExchangeDetails(exchange);
          const context = mapSingleExchangeToContext(exchange);
          setExchangeContext(context); // set updated context
          // set schedule type
          setScheduleType(context.from.scheduleType);
          // set exchange type
          setExchangeType(context.from.exchangeType);
          // check if editable
          setEdit(role && (role.access === 'All Access' || isReadOnlyWithExchangeRole) && EditExchangeDetailStatuses.includes(exchange.backEndStatus.toLowerCase()));
          setIsloading(false)
        }).catch((err) => {
          setExchangeDetails(undefined);
        });
      } else if (type === ScheduleTypeConstants.recurring && exchangeId) {
        setIsloading(true)
        findRecurringExchangeDetailsByAccountIdAndScheduleId({ accountId: userId, exchangeId }).then((res) => {
          const { recurringExchange: exchange } = res.data;
          setExchangeDetails(exchange);
          const context = mapRecurringExchangeToContext(exchange);
          // set updated context
          setExchangeContext(context);
          // set schedule type
          setScheduleType(context.from.scheduleType);
          // set exchange type
          setExchangeType(context.from.exchangeType);
          // check if editable
          //setEdit(Boolean(Number(exchange.noOfExchangesRemaining)));
          setEdit(role && (role.access === 'All Access' || isReadOnlyWithExchangeRole) && EditExchangeDetailStatuses.includes(exchange.status.toLowerCase()));
          setIsloading(false)
        }).catch((err) => {
          setExchangeDetails(undefined);
        });
      } else if (type === 'spawn' && exchPendingSpawnId) {
        setIsloading(true)
        findExchangeSpawnDetailsByScheduleIdAndSpawnId({ accountId: userId, exchangeId, exchPendingSpawnId }).then((res) => {
          const exchange = res.data;
          setExchangeDetails(exchange);
          const spawnContext = mapSpawnExchangeToContext(exchange);
          spawnContext.spawnRange = {...exchangeContext.spawnRange};
          spawnContext.from.startDate =  exchangeContext.spawnRange && exchangeContext.spawnRange.currentDate;
          //spawnContext.from.startDate = exchangeContext.spawnRange.currentDate;
          setExchangeContext(spawnContext); // set updated context
          // set schedule type
          setScheduleType(spawnContext.from.scheduleType);
          // set exchange type
          setExchangeType(spawnContext.from.exchangeType);
          // check if editable
          if (exchange.status === 'Active' || exchange.status === 'Entered' || exchange.status === 'Not scheduled') {
            setEdit((role && role.access === 'All Access' || isReadOnlyWithExchangeRole));
          }
          setIsloading(false)
        }).catch((err) => {
          setExchangeDetails(undefined);
        });
      }
    }
  }, [location]);

 

  const refreshExchangeDetails = () => {
    type === ScheduleTypeConstants.recurring && findRecurringExchangeDetailsByAccountIdAndScheduleId({ accountId: userId, exchangeId }).then((res) => {
      const { recurringExchange: exchange } = res.data;
      setExchangeDetails(exchange);
      const context = mapRecurringExchangeToContext(exchange);
      // set updated context
      setExchangeContext(context);
      setSpawnsLoading(false);
    }).catch((err) => {
      setExchangeDetails(undefined);
    });
  };

  const resetContextData = ({ scheduleType, exchangeType,  clearType }) => {
    const context = { ...exchangeContext };
    if (clearType && (clearType === 'from' || clearType === 'all')) {
      context.from.exchangeType = exchangeType;
      context.from.scheduleType = scheduleType;
      context.from.frequency = undefined;
      context.from.startDate = undefined;
      context.from.numberOfExchanges = undefined;
      context.from.endDate = undefined;
      context.from.pools = [];
      context.from.total = 0;
      context.from.allocationType = undefined;
    }
    if (clearType && (clearType === 'to' || clearType === 'all')) {
      context.to.pools = [];
    }
    setExchangeContext(context);
  };

  const persistContext = () => {
    setDirty(false);
    window.sessionStorage.setItem('recommend-an-exchange', JSON.stringify(exchangeContext));
  }
  const resetContext = () => {
    const context = initState();
    setExchangeContext(context);
  }

  
  const handleExitConfirmation = () => {
    setExit(false);
    trackExitButton(scheduleType, location);
    window.sessionStorage.removeItem('recommend-an-exchange')
    history.push('/');
  }

  const handleCancelConfirmation = () => {
    setCancel(false);
    resetContext();
    setDirty(false);
    isNew ? history.push(`/investments/recommend-an-exchange/${exchangeId}/review`)
      : history.push({
        pathname: `/investments/recommend-an-exchange/${exchangeId}/view`,
        search: location.search
      });
  }

  const handleExitSpawn = () => {
    setCancelSpawn(false);
    resetContext();
    history.push({
      pathname: `/investments/recommend-an-exchange/${exchangeId}/spawn/${exchPendingSpawnId}/view`,
      search: location.search
    });
  }

  const handleBack = () => {
    history.goBack(); 
  }

  const handleUpdateScheduleTypeAfterChanges = (isContinue) => {
    if (isContinue) { // user is Ok for loss of data, go ahead and change schedule type
      const { type } = isUpdateScheduleTypeAfterChanges;
      changeScheduleType(type);
      // Navigate to Step 1 if user changes schedule type in step 2 or step 3
      // const m = matchPath(location.pathname, {
      //   path: '/investments/recommend-an-exchange/:id/from'
      // });
      // if (m === null) {
        if(type !== ScheduleTypeConstants.tiff){
          window.sessionStorage.removeItem('recommend-an-exchange');
          history.push({
            pathname: `/investments/recommend-an-exchange/${exchangeId}/from`,
            // search: isNew && location.search
            state: {isReturned: true}
          });
        }
      // }
    }
    // else don't do anything and just close pop-up anyway
    setUpdateScheduleTypeAfterChanges({ display: false });
  }

  const trackScheduleTab = (type) => {
    if(type === ScheduleTypeConstants.onetime) {
      initiateTracking('tabClick', 'Recommend An Exchange', '', 'One Time Exchange');
    } else if (type === ScheduleTypeConstants.recurring) {
      initiateTracking('tabClick', 'Recommend An Exchange', '', 'Recurring Exchange')
    } else {
      initiateTracking('tabClick', 'Recommend An Exchange', '', 'TIFF Exchange')
    }
  }

  const handleChangeScheduleType = (type) => {
    const match = Boolean(matchPath(location.pathname, {
      path: "/investments/recommend-an-exchange/:id/from",
      exact: false,
      strict: false
    }));
    if (!match || (isNew && edit)) {
      setUpdateScheduleTypeAfterChanges({ display: true, type });
    } else if ((isNew && edit) || isDirty) {
      setUpdateScheduleTypeAfterChanges({ display: true, type });
    } else {
      changeScheduleType(type);
    }
  }

  const changeScheduleType = (type) => {
    // If user has pending recurring exchanges and willing to do recurring exchange business do not allow it.
    if (type === ScheduleTypeConstants.recurring && activeExchangeScheduleCount >= 3) {
      setMaxRecurring(true);
      trackScheduleTab(type);
      type = ScheduleTypeConstants.onetime;
    }

    /** NOTE: SPECIAL CASE This module is not supposed to handle TIFF exchange so refirecting to other URL */
    if (type === ScheduleTypeConstants.tiff) {
      setIsTiffClicked(true)
      if(!isPendingTiff) {
        trackScheduleTab(type)
        history.push(`/investments/recommend-an-exchange-tiff`);
      }
      return
    }
    trackScheduleTab(type)
    setScheduleType(type);
    // Set exchange type as per Schedule type
    const exchangeType = type === ScheduleTypeConstants.recurring ?
      ExchangeTypeConstants.custom
      : type === ScheduleTypeConstants.tiff ?
        ExchangeTypeConstants.fromTIFF
        : undefined
    setExchangeType(exchangeType);
    resetContextData({scheduleType: type, exchangeType, clearType: 'all'});
    setDirty(false);
  }

  const changeExchangeType = (type) => {
    let exchangeType = undefined;
    if ((investmentPoolOptions.hasPendingTransaction || hasTiffBalance ||  isPendingTiff || activeExchangeScheduleCount > 0) && type === ExchangeTypeConstants.reallocation) {
      setPendingTransactionForRellocationExchange(true);
      //exchangeType = ExchangeTypeConstants.custom;
    } else {
      exchangeType = type;
      setExchangeType(exchangeType);
      resetContextData({ scheduleType, exchangeType, clearType: 'from' });
      setDirty(true);
    }
  
  }

  const updatedEdit = edit && !isBalanceZero;
  if ((accountLocked && isNew) || (accountLocked && query.edit==="true")) {
    return (
      <AlertMessage
        className="alertFrozen"
        title="Account Locked"
        centered
        onOk={() => history.goBack()}
        onCancel={() => history.goBack()}
        visible={'true'}
        width="500px"
        footer={null}
      >
        Transactions for this account are frozen
        <br />
        Contact us at {ContactUsNumber} or <a href={`mailto:${ContactUsEmail}`}>{ContactUsEmail}</a>
      </AlertMessage>
    );
  }

  let isAllShareAllPoolExist=isAllShareAllPool();
  // block the new recommend exchange flow for Read Only account
  if (isAllShareAllPoolExist && isNew) {
    return (
      <AlertMessage
        className="alertReadOnly"
        title="Alert"
        centered
        onOk={() => history.goBack()}
        onCancel={() => history.goBack()}
        visible={'true'}
        width="500px"
        footer={null}
      >
        A grant has been recommended to close the account. Exchanges cannot be submitted.
      </AlertMessage>
    );
  }
  // block the new recommend exchange flow for Read Only account
  if (role && role.access === 'Read Only' && isNew && !isReadOnlyWithExchangeRole()) {
    return (
      <AlertMessage
        className="alertReadOnly"
        title="Account Read Only"
        centered
        onOk={() => history.goBack()}
        onCancel={() => history.goBack()}
        visible={'true'}
        width="500px"
        footer={null}
      >
        Your account is read only
        <br />
        Contact us at {ContactUsNumber} or <a href={`mailto:${ContactUsEmail}`}>{ContactUsEmail}</a>
      </AlertMessage>
    );
  }

  // block the new recommend exchange flow for Read Only account
  if (isNew && isBalanceZero) {
    return (
      <AlertMessage
        className="alertLowBalance"
        data-test="lowBalanceExchangeAlert"
        title={
          <AlertContent
              page={"Recommend an Exchange"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Low Balanace Exchange"}
              property={"field_header"}
          />
      }
        onOk={() => history.push('/')}
        onCancel={() => history.push('/')}
        visible={'true'}
        width="500px"
        footer={null}
        cancelText={
          <AlertContent
              page={"Recommend an Exchange"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Low Balanace Exchange"}
              property={"field_alert_button1_text"}
              defaultMessage={"CLOSE"}
              isButton={true}
          />
      }
      >
        <AlertContent            
            page={"Recommend an Exchange"}
            type={[Types.PAGE_ALERTS]}
            keyProperty={"Low Balanace Exchange"}
            property={"field_description"}
            html={true}
            defaultMessage={"You have insufficient balance to continue with this exchange."}
        /> 
      </AlertMessage>
    );
  }

  const steps = (props) => {
    const activeStepIndex = props.current;
    // `activeStepIndex === 0? 'true' : undefined` and key are added due to remove warnings from react        
    return [
      <Step active={activeStepIndex === 0 ? 'true' : undefined} key={'0'}
        description={<Popover
          overlayClassName='ant-popover-step-1'
          enablePopover={activeStepIndex > 0}
          onHoverContents={<ExchangeFromInfo location={location} scheduleType={scheduleType} history={history} stepData={exchangeContext.from} id={exchangeId} isDirty={isDirty} />}>
          <div className='ant-step-wrapper'>
            <Title name='Step 1' active={activeStepIndex === 0 ? 'true' : undefined} finished={updatedEdit || activeStepIndex > 0} />
            <span>{'Recommend exchange from'}</span>
          </div>
        </Popover>
        }
      />,
      <Step active={activeStepIndex === 1 ? 'true' : undefined} key={'1'}
        description={<Popover
          overlayClassName='ant-popover-step-2'
          enablePopover={activeStepIndex > 1}
          onHoverContents={<ExchangeToInfo location={location} history={history} scheduleType={scheduleType} totalAmount={exchangeContext.from.total} stepData={exchangeContext.to} id={exchangeId} isDirty={isDirty} />}>
          <div className='ant-step-wrapper'>
            <Title name='Step 2' active={activeStepIndex === 1 ? 'true' : undefined} finished={updatedEdit || activeStepIndex > 1} />
            <span>{'Recommend exchange to'}</span>
          </div>
        </Popover>
        }
      />,
      <Step active={activeStepIndex === 2 ? 'true' : undefined} key={'2'}
        description={<div className='ant-step-wrapper'>
          {/* step 3 pop over will not have any content as per FSD */}
          <Title name='Step 3' active={activeStepIndex === 2 ? 'true' : undefined} finished={updatedEdit || activeStepIndex > 2} />
          <span>{'Review exchange and submit'}</span>
        </div>
        }
      />,
    ];
  }

  return (
    <ContentProvider data-test ="content-provider"types={[Types.PAGE_NOTICES, Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_DISCLAIMERS, Types.PAGE_ALERTS]} pages={['Recommend an Exchange', 'Recommend an Exchange Confirmation', 'Exchange confirmation', 'Edit Exchange']}>
      <Provider value={{ exchangeContext, setExchangeContext }}>
        <RecommendExchangeSection>
          <Alerts
            isRecommendFrom={isRecommendFrom}
            isExit={isExit}
            setExit={setExit}
            handleExitConfirmation={handleExitConfirmation}
            isCancel={isCancel}
            setCancel={setCancel}
            isCancelSpawn={isCancelSpawn}
            handleExitSpawn={handleExitSpawn}
            setCancelSpawn={setCancelSpawn}
            handleCancelConfirmation={handleCancelConfirmation}
            isBalanceDiffWithPendingTransaction={isBalanceDiffWithPendingTransaction}
            setBalanceDiffWithPendingTransaction={setBalanceDiffWithPendingTransaction}
            isPendingTransactionForRellocationExchange={isPendingTransactionForRellocationExchange}
            setPendingTransactionForRellocationExchange={setPendingTransactionForRellocationExchange}
            isMaxRecurring={isMaxRecurring}
            setMaxRecurring={setMaxRecurring}
            isUpdateScheduleTypeAfterChanges={isUpdateScheduleTypeAfterChanges}
            handleUpdateScheduleTypeAfterChanges={handleUpdateScheduleTypeAfterChanges}
            isPendingTiff={isTiff && isPendingTiff}
            setIsTiffClicked={setIsTiffClicked}
          />
          <FixedWidth>
            <Route path={`/investments/recommend-an-exchange/:id/from`} render={() =>
              <>
                <AccountSummary
                 data-test="accountSummary"
                  breadcrumbRoutes={breadcrumbRoutes}
                  title={<ContentMessage page='Recommend an Exchange' type={Types.PAGE_TITLE_DESCRIPTION} property='field_page_title' defaultMessage='Recommend an exchange' />}
                  accountName={investmentPoolOptions.accountName}
                  accountId={investmentPoolOptions.accountId}
                  currentBalance={investmentPoolOptions.currentBalance}
                  availableBalance={investmentPoolOptions.availableBalance}
                  scheduleType={scheduleType}
                  handleChangeScheduleType={handleChangeScheduleType}
                  tradeCutoffDateAndTime={tradeCutoffDateAndTime}
                  isNew={isNew}
                />
                {isNew && <Stepper current={0} steps={(props) => steps(props)} >
                  <ExchangeFrom
                    investmentPoolOptions={investmentPoolOptions}
                    scheduleType={scheduleType}
                    exchangeType={exchangeType}
                    changeExchangeType={changeExchangeType}
                    handleExit={() => setExit(true)}
                    handleCancel={() => setCancel(true)}
                    handleBack={handleBack}
                    userId={userId}
                    edit={updatedEdit}
                    id={exchangeId}
                    persistContext={persistContext}
                    isDirty={isDirty}
                    isNew={isNew}
                    setDirty={setDirty}
                    exchangeDetails={exchangeDetails}
                    resetContext={resetContext}
                    handleCancelConfirmation={handleCancelConfirmation}
                    csrBusinessFunction={csrBusinessFunction}
                  />
                </Stepper>}
                {/**  Do not show stepper if existing exchange is being modified */}
                {!isNew && <ExchangeFrom
                  investmentPoolOptions={investmentPoolOptions}
                  scheduleType={scheduleType}
                  exchangeType={exchangeType}
                  changeExchangeType={changeExchangeType}
                  handleExit={() => setExit(true)}
                  handleCancel={() => setCancel(true)}
                  handleBack={handleBack}
                  userId={userId}
                  edit={updatedEdit}
                  id={exchangeId}
                  persistContext={persistContext}
                  isDirty={isDirty}
                  isNew={isNew}
                  setDirty={setDirty}
                  exchangeDetails={exchangeDetails}
                  resetContext={resetContext}
                  handleCancelConfirmation={handleCancelConfirmation}
                  csrBusinessFunction={csrBusinessFunction}
                />}
              </>} />
            <Route path={`/investments/recommend-an-exchange/:id/to`} render={({ match }) =>
              <>
                <AccountSummary
                  breadcrumbRoutes={breadcrumbRoutes}
                  title={<ContentMessage page='Recommend an Exchange' type={Types.PAGE_TITLE_DESCRIPTION} property='field_page_title' defaultMessage='Recommend An Exchange' />}
                  accountName={investmentPoolOptions.accountName}
                  accountId={investmentPoolOptions.accountId}
                  currentBalance={investmentPoolOptions.currentBalance}
                  availableBalance={investmentPoolOptions.availableBalance}
                  scheduleType={scheduleType}
                  handleChangeScheduleType={handleChangeScheduleType}
                  tradeCutoffDateAndTime={tradeCutoffDateAndTime}
                  isNew={isNew}
                />
                {isNew && <Stepper current={1} steps={(props) => steps(props)}>
                  <ExchangeTo
                    referencePools={investmentPoolOptions.investmentPools}
                    userId={userId}
                    handleExit={() => setExit(true)}
                    handleCancel={() => setCancel(true)}
                    handleBack={handleBack}
                    edit={updatedEdit}
                    id={exchangeId}
                    persistContext={persistContext}
                    isDirty={isDirty}
                    isNew={isNew}
                    setDirty={setDirty}
                    resetContext={resetContext}
                    exchangeDetails={exchangeDetails}
                    handleCancelConfirmation={handleCancelConfirmation}
                    accountType={accountType}
                    csrBusinessFunction={csrBusinessFunction}
                  />
                </Stepper>}
                {!isNew && <ExchangeTo
                  referencePools={investmentPoolOptions.investmentPools}
                  userId={userId}
                  handleExit={() => setExit(true)}
                  handleCancel={() => setCancel(true)}
                  handleBack={handleBack}
                  edit={updatedEdit}
                  id={exchangeId}
                  persistContext={persistContext}
                  isDirty={isDirty}
                  isNew={isNew}
                  setDirty={setDirty}
                  resetContext={resetContext}
                  exchangeDetails={exchangeDetails}
                  handleCancelConfirmation={handleCancelConfirmation}
                  accountType={accountType}
                  csrBusinessFunction={csrBusinessFunction}
                />}
              </>} />
            <Route path={`/investments/recommend-an-exchange/:id/review`} render={({ match }) =>
              <>
                <AccountSummary
                  breadcrumbRoutes={breadcrumbRoutes}
                  title={<ContentMessage page='Recommend an Exchange' type={Types.PAGE_TITLE_DESCRIPTION} property='field_page_title' defaultMessage='Recommend An Exchange' />}
                  accountName={investmentPoolOptions.accountName}
                  accountId={investmentPoolOptions.accountId}
                  currentBalance={investmentPoolOptions.currentBalance}
                  availableBalance={investmentPoolOptions.availableBalance}
                  scheduleType={scheduleType}
                  handleChangeScheduleType={handleChangeScheduleType}
                  tradeCutoffDateAndTime={tradeCutoffDateAndTime}
                  isNew={isNew}
                />
                <Stepper current={2} steps={(props) => steps(props)} >
                  <ExchangeReview
                    data-test="exchangeViewSomeWhere"
                    userId={userId}
                    handleExit={() => setExit(true)}
                    handleBack={handleBack}
                    getInitialData={getInitialData}
                    edit={updatedEdit}
                    id={exchangeId}
                    persistContext={persistContext}
                    isDirty={isDirty}
                    isNew={isNew}
                    csrBusinessFunction={csrBusinessFunction}
                  />
                </Stepper>
              </>} />
            <Route path={`/investments/recommend-an-exchange/:id/confirmation`} render={() =>
              <Confirmation
                handleExit={() => handleExitConfirmation()}
                exchangeDetails={exchangeDetails}
                setExchangeDetails={setExchangeDetails}
                userId={userId}
                handleBack={handleBack}
                getInitialData={getInitialData}
                edit={updatedEdit}
                id={exchangeId}
                isLoading={isLoading}
              />
            } />
            <Route path={`/investments/recommend-an-exchange/:id/view`} render={() =>
              <ViewAndEdit
                handleExit={() => setExit(true)}
                exchangeDetails={exchangeDetails}
                setExchangeDetails={setExchangeDetails}
                spawnsLoading={spawnsLoading}
                setSpawnsLoading={setSpawnsLoading}                
                userId={userId}
                handleBack={handleBack}
                getInitialData={getInitialData}
                edit={edit}
                id={exchangeId}
                persistContext={persistContext}
                isDirty={isDirty}
                refreshExchangeDetails={refreshExchangeDetails}
                isNew={isNew}
                isLoading={isLoading}
                isBalanceZero={isBalanceZero}
                csrBusinessFunction={csrBusinessFunction}
              />
            } />
            <Route exact path={`/investments/recommend-an-exchange/:id/spawn/:spawnid/view`} render={() =>
              <VeiwSpawn
                handleExit={() => setExit(true)}
                exchangeDetails={exchangeDetails}
                setExchangeDetails={setExchangeDetails}
                userId={userId}
                handleBack={handleBack}
                getInitialData={getInitialData}
                edit={updatedEdit}
                id={exchangeId}
                persistContext={persistContext}
                isDirty={isDirty}
                exchPendingSpawnId={exchPendingSpawnId}
                isLoading={isLoading}
              />
            } />
            <Route exact path={`/investments/recommend-an-exchange/:id/spawn/:spawnid/from`} render={() =>
              <ExchangeFrom
                investmentPoolOptions={investmentPoolOptions}
                scheduleType={scheduleType}
                exchangeType={exchangeType}
                changeExchangeType={changeExchangeType}
                handleExit={() => setExit(true)}
                handleCancel={() => setCancelSpawn(true)}
                handleBack={handleBack}
                userId={userId}
                edit={updatedEdit}
                id={exchangeId}
                persistContext={persistContext}
                isDirty={isDirty}
                isNew={isNew}
                setDirty={setDirty}
                exchangeDetails={exchangeDetails}
                spawnRange={exchangeContext.spawnRange}
                isSpawn={true}
                resetContext={resetContext}
                handleCancelConfirmation={handleExitSpawn}
                exchPendingSpawnId={exchPendingSpawnId}
                csrBusinessFunction={csrBusinessFunction}
              />
            } />
            <Route exact path={`/investments/recommend-an-exchange/:id/spawn/:spawnid/to`} render={() =>
              <ExchangeTo
                referencePools={investmentPoolOptions.investmentPools}
                userId={userId}
                handleExit={() => setExit(true)}
                handleCancel={() => setCancelSpawn(true)}
                handleBack={handleBack}
                edit={updatedEdit}
                id={exchangeId}
                persistContext={persistContext}
                isDirty={isDirty}
                isNew={isNew}
                setDirty={setDirty}
                isSpawn={true}
                resetContext={resetContext}
                exchangeDetails={exchangeDetails}
                handleCancelConfirmation={handleExitSpawn}
                exchPendingSpawnId={exchPendingSpawnId}
                accountType={accountType}
                csrBusinessFunction={csrBusinessFunction}
              />
            } />
            <Route exact path={props.match?.url} render={() => {
              window.sessionStorage.removeItem('recommend-an-exchange'); // clear data
              const context = getInitialData();
              setExchangeContext(getInitialData());
              // reset schedule type
              setScheduleType(context.from?.scheduleType);
              // reset exchange type
              setExchangeType(context.from?.exchangeType);
              // reset edit
              setEdit(false);
              return (<Redirect to={`/investments/recommend-an-exchange/NEW/from`} />)
            }} />
            <Route exact path={`${props.match?.url}/:id`} render={({ match }) => {
              window.sessionStorage.removeItem('recommend-an-exchange'); // clear data
              const context = getInitialData();
              setExchangeContext(getInitialData());
              // reset schedule type
              setScheduleType(context.from?.scheduleType);
              // reset exchange type
              setExchangeType(context.from?.exchangeType);
              return (<Redirect to={{
                pathname: `/investments/recommend-an-exchange/${match.params?.id}/view`,
                search: location.search,
              }} />)
            }} />
          </FixedWidth>
        </RecommendExchangeSection>
      </Provider>
    </ContentProvider>
  );
};

export default withRouter(RecommendAnExchange);
